const APP_BASE = ''
export const URL_CONST = {
  APPROVAL_RANGES: '/alcadas',
  BACKOFFICE: '/backoffice',
  EDI_MANAGEMENT: '/gestao-edi',
  EXPIREDPASSWORD: '/esqueci-minha-senha',
  EXTRA_VOLUME: '/volume-extra',
  FAIR_SHARE: '/fairshare',
  FINANCE_CHATBOT: '/chatbot_financeiro',
  INTERNATIONAL_SAMPLE_ORDER: '/amostra-internacional',
  KEY_ACCOUNTS: '/key-accounts',
  LEAD_TIMES: '/lead-times',
  LOGIN: '/login',
  MANAGE: '/gerenciar',
  MANAGE_ORDER: '/gerenciar/pedido',
  MANAGE_OV: '/gerenciar/ordem-venda',
  NATIONAL_SAMPLE_ORDER: '/amostra-nacional',
  ND: '/negociacao-diferenciada',
  NEW_ORDERS: '/pedidos/novo',
  ORDERS: '/pedidos',
  ORDERS_SIMULATE: '/simula',
  ORDERS_SUCCESS: '/sucesso',
  ORDERS_UNFOLD: '/resumo',
  ROOT: '/',
  SALES_CALENDAR: '/calendario-vendas',
  STOCK_REPORT: '/relatorio-estoque',
}
class Route<T> {
  public base: string
  public children: T

  constructor(base: string, children: T) {
    this.base = base
    this.children = children
  }

  private linkFactory = (key?: keyof T, childToGet?: T[keyof T]) => {
    if (key) {
      const child = this.children[key]
      let childAsPath = child instanceof Route ? child.base : child
      if (child instanceof Route && childToGet) {
        childAsPath = `${child.base}\\${child.children[childToGet]}`
      }

      return `${childAsPath}`.replace(/\//g, '').replace(/\\/g, '/')
    }
  }

  public getLink = (key?: keyof T, child?: T[keyof T]) => {
    let link = ''
    const baseUrl = this.base.replace(/\//g, '')

    if (APP_BASE) {
      link += `/${APP_BASE}`
    }

    if (baseUrl) {
      link += `/${baseUrl}`
    }

    link += `/${this.linkFactory(key, child)}`

    return link
  }
}

export const ROUTES = {
  app: new Route('/', {
    error: 'error',
    openPage: 'pagina-aberta',
  }),
  backoffice: new Route(URL_CONST.BACKOFFICE, {
    key_accounts: new Route(URL_CONST.KEY_ACCOUNTS, {}),
    lead_times: new Route(URL_CONST.LEAD_TIMES, {}),
    ranges: new Route(URL_CONST.APPROVAL_RANGES, {}),
  }),
  chatbot: new Route(URL_CONST.FINANCE_CHATBOT, {}),
  ediManagement: new Route(URL_CONST.EDI_MANAGEMENT, {}),
  extra_volume: new Route(URL_CONST.EXTRA_VOLUME, {}),
  fairShare: new Route(URL_CONST.FAIR_SHARE, {}),
  forgetPassword: new Route('/esqueci-minha-senha', {
    changedPassword: 'senha-alterada',
    resetPassword: 'redefinir-senha',
    validateCode: 'validar-codigo',
  }),
  login: new Route('/login', {}),
  manage: new Route('/gerenciar', {
    order: new Route('/pedido', {
      orderDetail: new Route('/:orderNumber', {
        orderMaterial: new Route('/:materialNumber', {}),
      }),
    }),
    ov: new Route('/ordem-venda', {
      ovDetail: new Route('/:ovNumber', {
        justificar: new Route('/justificar', {}),
        ovMaterial: new Route('/:materialNumber', {
          ovMaterialItem: '/:itemNumber',
        }),
      }),
    }),
  }),
  nd: new Route('/negociacao-diferenciada', {}),
  orders: new Route('/pedidos', {
    batchOrders: new Route('/lote', {
      franchises: new Route('/franquias', {}),
      international: new Route('/internacional', {}),
    }),
    internationalSampleOrder: new Route(URL_CONST.INTERNATIONAL_SAMPLE_ORDER, {}),
    nationalSampleOrder: new Route(URL_CONST.NATIONAL_SAMPLE_ORDER, {}),
    new: new Route('/novo', {}),
    orderDetail: new Route('/:orderNumber', {
      orderMaterials: '/:materialNumber',
      orderSimulate: '/simula',
    }),
  }),
  salesCalendar: new Route(URL_CONST.SALES_CALENDAR, {}),
  stock_report: new Route(URL_CONST.STOCK_REPORT, {}),
} as const
